const state = {
    headingProduceInformationFields: [
        {
            key: "item_title",
            label: "",
            sortable: false,
            class: "font-family-dfyuanstd-w5 table-col-hight"
        },
        {
            key: "unit_weight",
            label: "單支重(G)",
            sortable: false,
            class: "font-family-dfyuanstd-w5 table-col-hight"
        },
        {
            key: "standard_total_weight",
            label: "生產總重(KG)",
            sortable: false,
            class: "font-family-dfyuanstd-w5 table-col-hight"
        },
        {
            key: "material_total_weight",
            label: "原料使用總重(KG)",
            sortable: false,
            class: "font-family-dfyuanstd-w5 table-col-hight"
        },
    ], 
    headingProduceInformationItem: [
        // {
        //     "item_title": "實際",
        //     "qty": { name: "計數器支數", count: 130190 },
        //     "unit_weight": "4.65",
        //     "standard_total_weight": "-",
        //     "unit_material_weight": "-",
        //     "material_total_weight": "-",
        // },
        // {
        //     "item_title": "標準",
        //     "qty": { name: "派工支數", count: 361600 },
        //     "unit_weight": "4.65",
        //     "standard_total_weight": "1681.44",
        //     "unit_material_weight": "4.7",
        //     "material_total_weight": "1699.52",
        // }
    ],
}
const getters = {
    get_headingProduceInformationFields: state => {
        return state.headingProduceInformationFields
    },
    get_headingProduceInformationItem: state => {
        return state.headingProduceInformationItem
    },
}
const actions = {
    set_headingProduceInformationFields(context, array) {
        context.commit('SET_HEADINGPRODUCEINFORMATIONFIELDS', array);
    },
    set_headingProduceInformationItem(context, array) {
        context.commit('SET_HEADINGPRODUCEINFORMATIONITEM', array);
    },
}
const mutations = {
    SET_HEADINGPRODUCEINFORMATIONFIELDS(state, array) {
        state.headingProduceInformationFields = array;
    },
    SET_HEADINGPRODUCEINFORMATIONITEM(state, array) {
        state.headingProduceInformationItem = array;
    },
}

export default {
    namespaced: true,
    state,
    getters,
    actions,
    mutations
}



// WEBPACK FOOTER //
// ./src/store/modules/headingProduceInformation.js